export default "__VITE_ASSET__BaGoLdwU__"